export const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || "https://appproduct.alwsata.com.sa/api";


export const LEGACY_WEB_BASE_URL =
  process.env.VUE_APP_LEGACY_WEB_URL || "https://alwsata.test/";

/*
import { API_BASE_URL } from "./env";

export { API_BASE_URL };


export const LEGACY_WEB_BASE_URL = (() => {
  const configured = (process.env.VUE_APP_LEGACY_WEB_URL || "").trim();
  if (configured) {
    return configured.replace(/\/+$/, "");
  }

  const apiBase = (API_BASE_URL || "").replace(/\/+$/, "");
  if (apiBase.endsWith("/api")) {
    return apiBase.slice(0, -4);
  }

  return apiBase;
})();
*/
